/* eslint-disable import/no-extraneous-dependencies */
// ↑ dependenciesにリストされているのに😬
import $ from "jquery";
import "magnific-popup";
import "magnific-popup/dist/magnific-popup.css";
import SimpleBar from "simplebar";
import "simplebar/dist/simplebar.css";
import LazyLoad from "vanilla-lazyload";
import { uaCheck, mq } from "../modules/utils";

import "../sass/app.scss"; // メインCSS

uaCheck();

const g = {
  body: document.getElementsByTagName("body")[0],
};

/**
 * ページ内遷移のアニメーションの関数
 * href="#id名"があるaタグをクリックするとidの要素にスクロールする。
 * a[data-correction="pc時補正値, sp時補正値"]
 */
const smoothScrollFn = () => {
  const gap = mq("pc") ? 80 : 0;
  const triggers = document.querySelectorAll('a[href^="#"]');

  for (let i = 0; i < triggers.length; i += 1) {
    triggers[i].addEventListener("click", (e) => {
      e.preventDefault();
      const { hash } = triggers[i];
      const target = document.getElementById(hash.replace("#", ""));
      const { correction } = e.currentTarget.dataset;
      const corrArray = typeof correction === "undefined" ? [0, 0] : correction.split(",").map(Number);
      const corr = mq("pc") ? corrArray[0] : corrArray[1];

      if (target) {
        const rect = target.getBoundingClientRect().top;
        const offset = window.pageYOffset;
        const targetPos = rect + offset - gap + corr;

        window.scrollTo({
          top: targetPos,
          behavior: "smooth",
        });
      } else {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    });
  }
};

// レイジーロード
const lazyloadFn = () => {
  const ll = new LazyLoad();
  return ll;
};

// ポップアップメニュー
const magnificPopupFn = () => {
  const basicOptions = {
    closeOnBgClick: true,
    fixedContentPos: true,
  };
  // prettier-ignore
  const imageOption = { type: 'image' };
  const movieOption = { type: "iframe" };
  const inlineOption = { type: "inline" };
  const galleryOption = { gallery: { enabled: true } };

  const execute = (_target, _options) => {
    if ($(_target).length === 0) return;
    const options = Object.assign(basicOptions, _options);
    $(_target).magnificPopup(options);
  };

  execute(".js-mfp-image", imageOption);
  execute(".js-mfp-movie", movieOption);
  execute(".js-mfp-inline", inlineOption);
  execute(".js-mfp-image-gallery", Object.assign(imageOption, galleryOption));
  execute(".js-mfp-movie-gallery", Object.assign(movieOption, galleryOption));
  execute(".js-mfp-inline-gallery", Object.assign(inlineOption, galleryOption));
};

/**
 * 子の数によってcol1~col[max]のクラスをつける関数
 * @param {string} TARGET - ターゲットとするクラス名
 * @param {number} MAXCOLMN - 最大の数
 * @returns
 */
const addColNClassFunc = (TARGET, MAXCOLMN) => {
  const target = document.querySelectorAll(TARGET);
  if (!target) return;
  for (let i = 0; i < target.length; i += 1) {
    const { length } = target[i].children;
    const judge = length >= MAXCOLMN;
    target[i].classList.add(`is-type0${judge ? MAXCOLMN : length}`);
  }
};

/**
 * 任意の要素をクリックすると、任意の要素にクラスがついたり取れたりする関数
 * @param {string} _trigger クリックの対象となる要素のクラス名
 * @param {dom | string} _target クラスがトグルする要素のクラス名 デフォルトで_triggerと同値
 * @param {function} _function クリック時についで実行する関数
 * @param {string} _classname トグルするクラス名、デフォルトで’is-active’
 */
const toggleClassByClickFn = (_trigger, _target = _trigger, _function, _classname = "is-active") => {
  const trigger = document.querySelectorAll(_trigger);
  if (trigger.length === 0) return;

  // eslint-disable-next-line no-console
  let exec = () => console.log("ターゲット要素は無効です");

  // ターゲットがdomであれば
  if (_target instanceof HTMLElement) exec = (t) => t.classList.toggle(_classname);

  // ターゲットがストリングであり、その要素があれば
  if (typeof _target === "string")
    exec = (t) => {
      const TARGET = document.querySelectorAll(t);
      if (TARGET.length === 0) return;
      TARGET.forEach((_t) => _t.classList.toggle(_classname));
    };

  // クリックイベント
  trigger.forEach((_trg) =>
    _trg.addEventListener("click", () => {
      exec(_target);
      if (_function) _function();
    })
  );
};

/**
 * ヘッダー
 */
const header = {
  init: (_this) => {
    _this.switchMenu(_this);
    // toggleClassByScrollFn("#header", "body");
  },
  holdBody: () => {
    if (mq("pc")) return;
    const isShow = g.body.classList.contains("show-menu") || g.body.classList.contains("show-searchMenu");
    g.body.style.overflow = isShow ? "hidden" : "initial";
  },
  switchMenu: (_this) => {
    toggleClassByClickFn(".js-ht", g.body, _this.holdBody, "show-menu");
    toggleClassByClickFn(".js-closer-menu", g.body, _this.holdBody, "show-menu");
  },
};

/**
 * スクロールバー
 * 動的に高さが変わるので注意
 */
const scrollbar = {
  datasets: {
    trackPadding: {
      bottom: mq("pc") ? "5rem" : "3rem",
      right: "3rem",
    },
    /**
     * simplebar のスクロールバーを外に出すための処理
     * 1. 親要素と子要素を幅・高さで比較
     * 2. 子要素の方が大きい時paddingを与える。
     * @param {String} _target - 親要素であり、paddingが与えられる要素
     * @param {Object} _padding - paddingの値のデータセット。scrollbar.datasets.trackPaddingの参照を前提としている。
     * @returns
     */
    addPadding: (_target, _padding) => {
      const TARGET = _target;
      const content = TARGET.querySelector(".simplebar-content") || TARGET;
      if (!content) return;

      // paddingリセット
      TARGET.style.paddingBottom = "0px";
      TARGET.style.paddingRight = "0px";

      const { children } = content;

      const parentWidth = TARGET.clientWidth;
      let childWidth = 0;
      const parentHeight = TARGET.clientHeight;
      let childHeight = 0;

      // 一番大きい子要素に更新
      for (let i = 0; i < children.length; i += 1) {
        const child = children[i];
        if (childWidth < child.clientWidth) childWidth = child.clientWidth;
        if (childHeight < child.clientHeight) childHeight = child.clientHeight;
      }

      // 比較、padding付与
      if (childWidth > parentWidth) TARGET.style.paddingBottom = _padding.bottom;
      if (childHeight > parentHeight) TARGET.style.paddingRight = _padding.right;
    },
  },
  init: (_this) => {
    const target = document.querySelectorAll(".js-sb");
    if (target.length === 0) return;

    const options = {
      autoHide: false,
      scrollbarMinSize: 50,
    };

    target.forEach((_target) => {
      _this.addPadding(_target, _this.trackPadding);
      const sb = () => new SimpleBar(_target, options);
      sb();
    });
  },
  resize: (_this) => {
    const target = document.querySelectorAll(".js-sb");
    if (target.length === 0) return;
    target.forEach((_target) => _this.addPadding(_target, _this.trackPadding, true));
  },
};

document.addEventListener("DOMContentLoaded", () => {
  smoothScrollFn();
  lazyloadFn();
  magnificPopupFn();
  addColNClassFunc(".js-max-4", 4);
  addColNClassFunc(".js-max-3", 3);
  addColNClassFunc(".js-max-2", 2);
  header.init(header);
});

window.addEventListener("load", () => {
  scrollbar.init(scrollbar.datasets);
});

window.addEventListener("resize", () => {
  scrollbar.resize(scrollbar.datasets);
});
